// src/components/ui/TipsModal.js
import React, { useState, useEffect } from 'react';
import { Button } from './button';
import { Check } from 'lucide-react';
import axios from 'axios';
import { getVentaData, setVentaData } from '../../utils/ventaTemp';
import { lanzarPago } from '../../utils/IntentService'; // ajusta la ruta si es distinta
import API_BASE_URL from '../../Config';

export function TipsModal({
  showTipsModal,
  onPaymentSuccess,
  currentOrder,
  setShowTipsModal,
  totalAmount,
  onConfirm,
  onCancel
}) {
    const [paymentStatus, setPaymentStatus] = useState(null);
  const [tip, setTip] = useState('');
  const [selectedWaiter, setSelectedWaiter] = useState('');
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [mozos, setMozos] = useState([]);
  const [descuentos, setDescuentos] = useState([]);


  useEffect(() => {
    if (showTipsModal) {
      fetch(`${API_BASE_URL}/api/mozos`)
        .then((res) => res.json())
        .then((data) => setMozos(data))
        .catch((err) => console.error('Error al cargar mozos:', err));

      axios
        .get(`${API_BASE_URL}/api/descuentos`)
        .then((res) => setDescuentos(res.data))
        .catch((err) => console.error('Error al cargar descuentos:', err));
    }
  }, [showTipsModal]);

  const aplicarDescuentos = (items, descuentos) => {
    const hoy = new Date().toISOString().split('T')[0];
    let descuentoTotal = 0;

    const productosConDescuento = items.map((item) => {
      const descuento = descuentos.find((d) => {
        return (
          Number(d.productoId) === Number(item.productId) && d.fecha === hoy
        );
      });

      const porcentaje = descuento ? Number(descuento.porcentajeDescuento) : 0;
      const precioOriginal = item.price * item.quantity;
      const montoDescuento = (precioOriginal * porcentaje) / 100;
      descuentoTotal += montoDescuento;

      return {
        ...item,
        precioFinal: precioOriginal - montoDescuento
      };
    });

    const totalConDescuento = productosConDescuento.reduce(
      (acc, item) => acc + item.precioFinal,
      0
    );

    return { totalConDescuento, descuentoTotal, productosConDescuento };
  };

  const handleConfirm = async () => {
    if (!selectedWaiter) {
      alert('Por favor selecciona un mozo antes de continuar.');
      return;
    }

    if (currentOrder?.items && Array.isArray(currentOrder.items)) {
      const propinaValor = Number(tip || 0);
      const { totalConDescuento, descuentoTotal, productosConDescuento } =
        aplicarDescuentos(currentOrder.items, descuentos);
      const totalFinal = totalConDescuento + propinaValor;

      const previo = getVentaData();
      setVentaData({
        ...previo,
        mesa: currentOrder.name,
        productos: productosConDescuento.map((item) => ({
          id: item.productId,
          nombre: item.productName,
          precio: item.precioFinal / item.quantity,
          cantidad: item.quantity
        })),
        propina: propinaValor,
        mozo: selectedWaiter,
        total: totalFinal,
        descuento: descuentoTotal,
        exenta: propinaValor
      });
    }

    setTip('');
    setSelectedWaiter('');
    setShowSuccessMessage(true);

    if (getVentaData().metodoPago === 'card') {
    console.log('👉 Disparando intent de pago con tarjeta desde TipsModal...');
    try {
        const pagoResult = await lanzarPago({
            amountBuy: totalAmount.toString(),
            amountChange: '0',
            currencyCode: '600',
            printVoucher: 'true',
            promotions: '',
            providerId: '0001'
        });
        console.log('💳 Resultado del intent:', pagoResult);

        if (!pagoResult || pagoResult.responseCode !== '00') {
            console.warn('⛔ Pago con tarjeta rechazado en POS.');
            setShowTipsModal(false);
            setShowSuccessMessage(false);
            return;
        }
    } catch (error) {
        console.error('⛔ Error al lanzar el intent de pago:', error);
        setShowTipsModal(false);
        setShowSuccessMessage(false);
        return;
    }
}
    







    setTimeout(async () => {

      setShowSuccessMessage(false);
      setShowTipsModal(false);

      const mozoSeleccionado = mozos.find(
        (m) => m.id === parseInt(selectedWaiter)
      );

      onConfirm?.({
        tip: tip,
        mozo: mozoSeleccionado
      });
    }, 3000);
  };

  if (!showTipsModal) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg w-full max-w-md">
        {showSuccessMessage ? (
          <div className="text-center py-4">
            <Check className="h-16 w-16 text-green-500 mx-auto mb-2" />
            <h3 className="font-bold text-lg text-green-500">Pago Aceptado</h3>
            <p className="text-gray-600">El pago se ha procesado correctamente</p>
            <p className="text-gray-600 mt-1">
              Mozo: <strong>{selectedWaiter}</strong>
            </p>
            <p className="text-gray-600 mt-1">
              Propina: <strong>Gs {Number(tip || 0)}</strong>
            </p>
            <p className="text-gray-600 mt-1">
              Total con propina: <strong>Gs {Number(tip || 0) + totalAmount}</strong>
            </p>
          </div>
        ) : (
          <>
            <h2 className="text-xl font-bold mb-4 text-center">Cargar Propina</h2>

            <p className="mb-2 text-center text-gray-600">
              Monto total pagado: <strong>Gs {totalAmount}</strong>
            </p>

            <input
              type="number"
              placeholder="Monto de la propina"
              value={tip}
              onChange={(e) => setTip(e.target.value)}
              className="w-full px-3 py-2 border rounded-md text-sm mb-4"
            />

            <select
              value={selectedWaiter}
              onChange={(e) => setSelectedWaiter(e.target.value)}
              className="w-full px-3 py-2 border rounded-md text-sm mb-4"
            >
              <option value="">Seleccionar mozo</option>
              {mozos.map((mozo) => (
                <option key={mozo.id} value={mozo.id}>
                  {mozo.nombre} ({mozo.ci})
                </option>
              ))}
            </select>

            <div className="flex justify-between">
<Button variant="outline" onClick={() => {
  setShowTipsModal(false);
  setPaymentStatus(null);
  onCancel?.(); // ✅ ejecuta el callback desde PaymentModal
}}>                Cancelar
              </Button>
              <Button onClick={handleConfirm}>Confirmar Propina</Button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
